import {NgModule} from '@angular/core';
import {WorkHistoryNotesService} from './work-history-notes.service';


@NgModule({
    providers: [
        WorkHistoryNotesService
    ]
})
export class WorkHistoryNotesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/work-history-notes/work-history-notes.module.ts